export default __webpack_public_path__ + "static/6. Seamless fee management 2-02053cc9b92aacda98ef93749094d386.png";